const g = {
  color: {
    black: "#000",
    blueDark: "#003767",
    blueLight: "#028fbc",
    gray: "#666",
    yellow: "#eec215",
  },

  el: {
    accordions: document.querySelectorAll(".accordion"),
    contact: document.querySelector(".contact"),
    events: document.querySelectorAll(".event"),
    footer: document.querySelector(".footer"),
    formFields: document.querySelectorAll(
      ".fieldset input[type=text], .fieldset input[type=password], .fieldset input[type=date], .fieldset select, .fieldset textarea"
    ),
    header: document.querySelector(".header:not(.header-login)"),
    search: document.querySelectorAll(".search"),
    icons: document.querySelectorAll("svg[data-icon]"),
    layout: document.querySelector(".layout"),
    loader: document.querySelector(".loader"),
    megamenus: document.querySelectorAll(".megamenu"),
    modal: document.querySelector(".modal"),
    staff: document.querySelectorAll(".staff"),
    bankruptcy: document.querySelectorAll(".js-bankruptcy"),
    searchResults: document.querySelector(".search-results"),
    newsSlider: document.querySelector(".news-slider"),
    webchatButton: document.querySelector("#chat-button"),
    //* My pages
    membershipFees: document.querySelector(".js-membership--fees"),
    tabs: document.querySelectorAll(".tabs"),
    memberSalary: document.querySelector(".js-section--salary"),
    memberFees: document.querySelector(".js-mp-fees"),
    memberTaxReturn: document.querySelector(".js-mp-tax"),
    eventUnSubscribe: document.querySelectorAll(".js-mp-event"),
    memberApplicationForm: document.querySelector(".js-member-application"),
    funds: document.querySelector(".mp-funds"),
    fakeSelect: document.querySelectorAll(".fake-select"),
    memberSalaryHistory: document.querySelector(".js-section--salaryHistory"),
    bannerSlider: document.querySelector(".banner-slider"),
  },

  form: {
    //* subscriptions
    eventSubscribe: document.querySelectorAll(".form_event_subscribe"),
    newsletterSubscribe: document.forms.form_newsletter_subscribe,
    magazineSubscribe: document.forms.form_magazine_subscribe,
    //* My pages
    certificateSMS: document.forms.form_member_sendsms,
    certificateEmail: document.forms.form_member_sendemail,
    memberSettings: document.forms.form_member_settings,
    strikeForm: document.forms.form_member_strike,
    memberSubsidyForm: document.forms.form_member_subsidy,
    memberRegister: document.forms.form_member_register,
    holidayCottageRedirect: document.forms.form_holiday_cottage,
    //* calculators
    calculateWorkingTime: document.forms.form_calculate_time,
    decemberBonus: document.forms.calculator_december_allowance,
    holidayAllowance: document.forms.calculator_holiday_allowance,
    paycheckCalculator: document.forms.calculator_paycheck,
    realEstatePurchase: document.forms.calculator_realestate_purchase,
    salarySurveyCalculator: document.forms.calculator_salary_survey,
    wageDevelopmentsCalculator: document.forms.calculator_wage_developments,
    professionSalaryCalc: document.forms.calculator_profession_salary,
    //* Other forms
    eventRegistration: document.forms.form_event_registration,
    suggestions: document.forms.form_suggestion,
    registration: document.forms.form_registration,
  },

  isIE11: navigator.userAgent.match(/Trident.*rv:11\./),

  resolution: {
    s: 576,
    m: 775,
    l: 992,
    xl: 1125,
  },
};

export default g;
